"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/cms_service.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSDashboardServiceGetFilterValuesResponse = exports.CMSDashboardServiceGetFilterValuesRequest = exports.CMSDashboardServiceGetDashboardGraphByIdResponse = exports.CMSDashboardServiceGetDashboardGraphByIdRequest = exports.CMSDashboardServiceGetDashboardGraphGroupsResponse = exports.CMSDashboardServiceGetDashboardGraphGroupsRequest = exports.CMSDashboardServiceCreateOAuthRefreshTokenResponse = exports.CMSDashboardServiceCreateOAuthRefreshTokenRequest = exports.CMSDashboardServiceGetOAuthRedirectUrlResponse = exports.CMSDashboardServiceGetOAuthRedirectUrlRequest = exports.CMSDashboardServiceGetYoutubeAccountResponse = exports.CMSDashboardServiceGetYoutubeAccountRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const cms_common_pb_1 = require("./cms_common_pb");
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetYoutubeAccountRequest
 */
class CMSDashboardServiceGetYoutubeAccountRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * FIXME: headerに入れて認証情報から取得する
         *
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetYoutubeAccountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetYoutubeAccountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetYoutubeAccountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetYoutubeAccountRequest, a, b);
    }
}
exports.CMSDashboardServiceGetYoutubeAccountRequest = CMSDashboardServiceGetYoutubeAccountRequest;
CMSDashboardServiceGetYoutubeAccountRequest.runtime = protobuf_1.proto3;
CMSDashboardServiceGetYoutubeAccountRequest.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetYoutubeAccountRequest";
CMSDashboardServiceGetYoutubeAccountRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetYoutubeAccountResponse
 */
class CMSDashboardServiceGetYoutubeAccountResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetYoutubeAccountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetYoutubeAccountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetYoutubeAccountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetYoutubeAccountResponse, a, b);
    }
}
exports.CMSDashboardServiceGetYoutubeAccountResponse = CMSDashboardServiceGetYoutubeAccountResponse;
CMSDashboardServiceGetYoutubeAccountResponse.runtime = protobuf_1.proto3;
CMSDashboardServiceGetYoutubeAccountResponse.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetYoutubeAccountResponse";
CMSDashboardServiceGetYoutubeAccountResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "youtube_account", kind: "message", T: cms_common_pb_1.CMSDashboardYoutubeAccount },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetOAuthRedirectUrlRequest
 */
class CMSDashboardServiceGetOAuthRedirectUrlRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetOAuthRedirectUrlRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetOAuthRedirectUrlRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetOAuthRedirectUrlRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetOAuthRedirectUrlRequest, a, b);
    }
}
exports.CMSDashboardServiceGetOAuthRedirectUrlRequest = CMSDashboardServiceGetOAuthRedirectUrlRequest;
CMSDashboardServiceGetOAuthRedirectUrlRequest.runtime = protobuf_1.proto3;
CMSDashboardServiceGetOAuthRedirectUrlRequest.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetOAuthRedirectUrlRequest";
CMSDashboardServiceGetOAuthRedirectUrlRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetOAuthRedirectUrlResponse
 */
class CMSDashboardServiceGetOAuthRedirectUrlResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * google認証画面にredirectされる時に使用されるurl
         *
         * @generated from field: string redirect_url = 1;
         */
        this.redirectUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetOAuthRedirectUrlResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetOAuthRedirectUrlResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetOAuthRedirectUrlResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetOAuthRedirectUrlResponse, a, b);
    }
}
exports.CMSDashboardServiceGetOAuthRedirectUrlResponse = CMSDashboardServiceGetOAuthRedirectUrlResponse;
CMSDashboardServiceGetOAuthRedirectUrlResponse.runtime = protobuf_1.proto3;
CMSDashboardServiceGetOAuthRedirectUrlResponse.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetOAuthRedirectUrlResponse";
CMSDashboardServiceGetOAuthRedirectUrlResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceCreateOAuthRefreshTokenRequest
 */
class CMSDashboardServiceCreateOAuthRefreshTokenRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * google認証画面からredirectされてきた時にurlに存在しているcodeというqueryParameterの値
         *
         * @generated from field: string code = 1;
         */
        this.code = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceCreateOAuthRefreshTokenRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceCreateOAuthRefreshTokenRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceCreateOAuthRefreshTokenRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceCreateOAuthRefreshTokenRequest, a, b);
    }
}
exports.CMSDashboardServiceCreateOAuthRefreshTokenRequest = CMSDashboardServiceCreateOAuthRefreshTokenRequest;
CMSDashboardServiceCreateOAuthRefreshTokenRequest.runtime = protobuf_1.proto3;
CMSDashboardServiceCreateOAuthRefreshTokenRequest.typeName = "spwn.dashboard.v1.CMSDashboardServiceCreateOAuthRefreshTokenRequest";
CMSDashboardServiceCreateOAuthRefreshTokenRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceCreateOAuthRefreshTokenResponse
 */
class CMSDashboardServiceCreateOAuthRefreshTokenResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceCreateOAuthRefreshTokenResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceCreateOAuthRefreshTokenResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceCreateOAuthRefreshTokenResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceCreateOAuthRefreshTokenResponse, a, b);
    }
}
exports.CMSDashboardServiceCreateOAuthRefreshTokenResponse = CMSDashboardServiceCreateOAuthRefreshTokenResponse;
CMSDashboardServiceCreateOAuthRefreshTokenResponse.runtime = protobuf_1.proto3;
CMSDashboardServiceCreateOAuthRefreshTokenResponse.typeName = "spwn.dashboard.v1.CMSDashboardServiceCreateOAuthRefreshTokenResponse";
CMSDashboardServiceCreateOAuthRefreshTokenResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphGroupsRequest
 */
class CMSDashboardServiceGetDashboardGraphGroupsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetDashboardGraphGroupsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetDashboardGraphGroupsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetDashboardGraphGroupsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetDashboardGraphGroupsRequest, a, b);
    }
}
exports.CMSDashboardServiceGetDashboardGraphGroupsRequest = CMSDashboardServiceGetDashboardGraphGroupsRequest;
CMSDashboardServiceGetDashboardGraphGroupsRequest.runtime = protobuf_1.proto3;
CMSDashboardServiceGetDashboardGraphGroupsRequest.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphGroupsRequest";
CMSDashboardServiceGetDashboardGraphGroupsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphGroupsResponse
 */
class CMSDashboardServiceGetDashboardGraphGroupsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardGraphGroup graph_group_list = 1;
         */
        this.graphGroupList = [];
        /**
         * dashboardのgraphのデータの最終更新時刻
         *
         * @generated from field: int64 last_updated_at = 2;
         */
        this.lastUpdatedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetDashboardGraphGroupsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetDashboardGraphGroupsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetDashboardGraphGroupsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetDashboardGraphGroupsResponse, a, b);
    }
}
exports.CMSDashboardServiceGetDashboardGraphGroupsResponse = CMSDashboardServiceGetDashboardGraphGroupsResponse;
CMSDashboardServiceGetDashboardGraphGroupsResponse.runtime = protobuf_1.proto3;
CMSDashboardServiceGetDashboardGraphGroupsResponse.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphGroupsResponse";
CMSDashboardServiceGetDashboardGraphGroupsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "graph_group_list", kind: "message", T: cms_common_pb_1.CMSDashboardGraphGroup, repeated: true },
    { no: 2, name: "last_updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphByIdRequest
 */
class CMSDashboardServiceGetDashboardGraphByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphId graph_id = 1;
         */
        this.graphId = cms_common_pb_1.CMSDashboardGraphId.CMS_DASHBOARD_GRAPH_ID_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetDashboardGraphByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetDashboardGraphByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetDashboardGraphByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetDashboardGraphByIdRequest, a, b);
    }
}
exports.CMSDashboardServiceGetDashboardGraphByIdRequest = CMSDashboardServiceGetDashboardGraphByIdRequest;
CMSDashboardServiceGetDashboardGraphByIdRequest.runtime = protobuf_1.proto3;
CMSDashboardServiceGetDashboardGraphByIdRequest.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphByIdRequest";
CMSDashboardServiceGetDashboardGraphByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "graph_id", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSDashboardGraphId) },
    { no: 2, name: "plan_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "period", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 4, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "goods_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphByIdResponse
 */
class CMSDashboardServiceGetDashboardGraphByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetDashboardGraphByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetDashboardGraphByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetDashboardGraphByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetDashboardGraphByIdResponse, a, b);
    }
}
exports.CMSDashboardServiceGetDashboardGraphByIdResponse = CMSDashboardServiceGetDashboardGraphByIdResponse;
CMSDashboardServiceGetDashboardGraphByIdResponse.runtime = protobuf_1.proto3;
CMSDashboardServiceGetDashboardGraphByIdResponse.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetDashboardGraphByIdResponse";
CMSDashboardServiceGetDashboardGraphByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "graph", kind: "message", T: cms_common_pb_1.CMSDashboardGraph },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetFilterValuesRequest
 */
class CMSDashboardServiceGetFilterValuesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetFilterValuesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetFilterValuesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetFilterValuesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetFilterValuesRequest, a, b);
    }
}
exports.CMSDashboardServiceGetFilterValuesRequest = CMSDashboardServiceGetFilterValuesRequest;
CMSDashboardServiceGetFilterValuesRequest.runtime = protobuf_1.proto3;
CMSDashboardServiceGetFilterValuesRequest.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetFilterValuesRequest";
CMSDashboardServiceGetFilterValuesRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardServiceGetFilterValuesResponse
 */
class CMSDashboardServiceGetFilterValuesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardPlan plan_list = 1;
         */
        this.planList = [];
        /**
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardGoods goods_list = 2;
         */
        this.goodsList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardServiceGetFilterValuesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardServiceGetFilterValuesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardServiceGetFilterValuesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardServiceGetFilterValuesResponse, a, b);
    }
}
exports.CMSDashboardServiceGetFilterValuesResponse = CMSDashboardServiceGetFilterValuesResponse;
CMSDashboardServiceGetFilterValuesResponse.runtime = protobuf_1.proto3;
CMSDashboardServiceGetFilterValuesResponse.typeName = "spwn.dashboard.v1.CMSDashboardServiceGetFilterValuesResponse";
CMSDashboardServiceGetFilterValuesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "plan_list", kind: "message", T: cms_common_pb_1.CMSDashboardPlan, repeated: true },
    { no: 2, name: "goods_list", kind: "message", T: cms_common_pb_1.CMSDashboardGoods, repeated: true },
]);
//# sourceMappingURL=cms_service_pb.js.map